import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { FilterType, WidgetFilter } from "@core/models/analytics-dashboard-enums";
import { AnalyticsWidgetService } from "src/app/services/analytics-widget/analytics-widget.service";
import { Subscription, takeUntil } from "rxjs"; // Import Subscription
import { TopIcContributers } from "@core/models/analytics-dashboard-models";
import { lastn } from "@core/models/analytics-dashboard-constants";
import { ElevationReportService } from "src/app/services/elevation-report/elevation-report.service";
import { BreakInMember } from "src/app/components/elevation-report/elevation-report.component";
import { RouterService } from "src/app/services/router/router.service";
import { Nullable } from "primeng/ts-helpers";

@Component({
  selector: "bpc-break-ins-leaderboard-widget",
  templateUrl: "./break-ins-leaderboard-widget.component.html",
  styleUrls: ["./break-ins-leaderboard-widget.component.scss"],
})
export class BreakInsLeaderboardWidget {
  // Implement OnDestroy
  @Input() title!: string;
  @Input() loaders!: number | undefined;

  selectedFilters: any = [];
  filters: WidgetFilter[] = [/*{ filterType: FilterType.last_n, options: lastn, default: lastn[4] }*/];
  data!: BreakInMember[] 
  loading: boolean = true;
  activeMember!: Nullable<BreakInMember>;

  @Output() showGrid = new EventEmitter<{companyIds: number[]}>();
  @Output() hideGrid = new EventEmitter<{}>();

  private refreshSubscription!: Subscription;

  constructor(
    private analyticsWidgetService: AnalyticsWidgetService,
    private elevationReportService: ElevationReportService,
    private routerService: RouterService,
  ) {
    this.selectedFilters = { last_n: lastn[4] };
    this.refreshSubscription = this.analyticsWidgetService.refreshData.subscribe((companyIds)=>{
      if (this.activeMember?.companyIds != companyIds){
        this.activeMember = null;
      }
    })
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.elevationReportService.getBreakinCredits(this.selectedFilters.last_n.id)
      .pipe(takeUntil(this.routerService.destroy$))
      .subscribe(response => {
      if (response.data) {
        this.data = response.data.results;
        this.loading = false;
      }
    });
  }

  getCompaniesForUser(breakIn: BreakInMember){
    this.activeMember = breakIn;
    this.showGrid.emit({companyIds : breakIn?.companyIds!});
    this.analyticsWidgetService.breakInCompanyIds = [];
    this.analyticsWidgetService.refreshData.next(breakIn.companyIds!);
  }

  onFilterChange(selectedFilters: any) {
    this.selectedFilters = selectedFilters;
    this.getData();
  }

  onContributorClick(contributor: TopIcContributers) {
    this.analyticsWidgetService.loadUserIcs(contributor, this.selectedFilters.last_n);
  }

  ngOnDestroy() {
    this.refreshSubscription?.unsubscribe();
  }
}
